// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/Metrics/metrics.scss
// module id = 71
// module chunks = 0